export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/array.js
// module id = 704
// module chunks = 0